module.exports = __webpack_public_path__ + "img/top-title.deef2914.png";